import { postNewCalendarEvent, postCalendarEventBulkImport, getRoutedBuilding } from '../api.js'

import pageApiData from '../utils/pageApiData.js'
import notifications from '../notifications.js'

const [ _getRoutedBuildingFromServer, _getRoutedBuilding, _getRoutedBuildingSync ] = pageApiData.createFunctions(getRoutedBuilding, 'Unable to get buildings from server.', function (code) { return elem => elem.code === code })

function _postNewCalendarEvent(content) {
  let promise = postNewCalendarEvent(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _postCalendarEventBulkImport(file) {
  const formData = new FormData()
  formData.append('calendar_event_file', file)

  let promise = postCalendarEventBulkImport(formData, { 'Content-Type': 'multipart/form-data' })

  promise
    .then(response => {
      notifications.pushInfo(`Bulk import complete, ${response.data.created} event(s) created.`)
    })
    .catch(error => {
      const rowErrors = error.response?.data?.errors
      if (rowErrors) {
        const message = rowErrors.map(rowError => `Line ${rowError.line}: ${rowError.errors.join(', ')}`).join('; ')
        notifications.pushError(`Bulk import failed! ${message}`, error)
      } else {
        notifications.pushError(`Bulk import failed! ${error.response?.data}`, error)
      }
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  getRoutedBuildingFromServer: _getRoutedBuildingFromServer,
  getRoutedBuilding: _getRoutedBuilding,
  getRoutedBuildingSync: _getRoutedBuildingSync,

  postNewCalendarEvent: _postNewCalendarEvent,
  postCalendarEventBulkImport: _postCalendarEventBulkImport,
}
